import React, { useRef, useState } from "react";
import backgroundIcon from "../../assets/images/background_icon.svg";
import { useNavigate } from "react-router-dom";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { changePassword } from "../../api/admin-users";
import toast from "react-hot-toast";


const ChangePassword = () => {
  const navigate = useNavigate();

  const adminUser = JSON.parse(localStorage.getItem("adminUser"));

  const [email, setEmail] = useState(adminUser?.email);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  // UI state
  const [submitting, setSubmitting] = useState(false);
  const [showStrength, setShowStrength] = useState(true);

  const passMatch = newPassword && confirm && newPassword === confirm;


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const res = await changePassword({ email, currentPassword, newPassword, confirmPassword: confirm });
      console.log("RES", res);
      if(!res.success)  {
        toast.error(res.message);
      }
      else {
        toast.success(res.message);
        navigate("/");
      }
    } catch (err) {
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-[75vh] max-h-[90vh] bg-white"
      style={{
        backgroundImage: `url(${backgroundIcon})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right",
      }}
    >

      <div className="max-w-6xl mx-auto px-4 my-auto min-h-[95vh] max-h-[100vh]">
        {/* Header */}
        <div className="pt-16 md:pt-24 text-center">
          <h1 className="text-2xl md:text-3xl font-bold">
            Reset <span className="text-primary">Password</span>
          </h1>
        </div>

        <div className="mt-10 flex justify-center">
          <div className="w-full max-w-lg bg-white rounded-2xl shadow-lg ring-1 ring-gray-100 p-6 md:p-8">
            <form onSubmit={handleSubmit} className="space-y-5">

              {/* Current Password */}
              <div className="flex flex-col gap-2 w-full">
                <label htmlFor="password" className="text-sm font-medium text-gray-700">
                  Current Password
                </label>
                <Password
                  id="currentPassword"
                  value={currentPassword}
                  onChange={(e) =>  setCurrentPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  toggleMask
                  className="w-full"
                  inputClassName="!w-full rounded-md border border-slate-300 bg-white px-4 py-3 text-sm text-slate-700 placeholder-slate-400 focus:border-slate-400 focus:ring-2 focus:ring-slate-300 focus:outline-none transition"
                  promptLabel="Create a strong password"
                  feedback={false}
                />
              </div>

              {/* New Password */}
              <div className="flex flex-col gap-2 w-full">
                <label htmlFor="password" className="text-sm font-medium text-gray-700">
                  New Password
                </label>
                <Password
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) =>  setNewPassword(e.target.value)}
                  placeholder="At least 8 characters"
                  toggleMask
                  className="w-full"
                  inputClassName="!w-full rounded-md border border-slate-300 bg-white px-4 py-3 text-sm text-slate-700 placeholder-slate-400 focus:border-slate-400 focus:ring-2 focus:ring-slate-300 focus:outline-none transition"
                  feedback={false}
                />
              </div>

              {/* Confirm */}
              <div className="flex flex-col gap-2 w-full">
                <label htmlFor="confirm" className="text-sm font-medium text-gray-700">
                  Confirm Password
                </label>
                <Password
                  id="confirm"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Re-enter password"
                  toggleMask
                  
                  className="w-full"
                  inputClassName={`!w-full rounded-md px-4 py-3 text-sm focus:outline-none transition ${
                    confirm && !passMatch
                      ? "border-red-500 ring-red-200"
                      : "border border-slate-300 bg-white text-slate-700 placeholder-slate-400 focus:border-slate-400 focus:ring-2 focus:ring-slate-300"
                  }`}
                  feedback={false}
                />
                {!!confirm && !passMatch && (
                  <small className="text-red-600">Passwords do not match.</small>
                )}
              </div>

              {/* Submit Button */}
              <Button
                type="submit"
                label={submitting ? "Updating..." : "Update Password"}
                disabled={!(currentPassword && newPassword && confirm) || submitting}
                className="w-full justify-center bg-primary text-white border-0 hover:bg-primary/90 transition py-1"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
